// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-readme-mdx": () => import("./../src/README.mdx" /* webpackChunkName: "component---src-readme-mdx" */),
  "component---src-button-readme-mdx": () => import("./../src/Button/README.mdx" /* webpackChunkName: "component---src-button-readme-mdx" */)
}

